<template v-slot:activator="{ on }">
  <v-dialog
    v-model="exibedialogInterno"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="fechaDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>INFORMATIVO DE RENDIMENTOS PARA DECLARAÇÃO DE IMPOSTO DE RENDA</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="fechaDialog()"
          >
            Fechar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider />
      <!-- CARD CABEÇALHO -->
      <v-card
        id="dashboard-card-cabecalho"
        class="mx-au"
        outlined
        elevation="1"
      >
        <v-card-text
          id="teste"
          class="ma-2 ml-2 mr-2"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
            >
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <p v-if="movimentacao && movimentacao.produtor">
                    <b>Produtor: </b>{{ movimentacao.produtor.nome }}
                  </p>
                  <p v-if="movimentacao && movimentacao.nomePropriedade">
                    <b>Propriedade: </b>{{ movimentacao.nomePropriedade }}
                  </p>
                  <p v-if="movimentacao && movimentacao.produtor">
                    <b>Endereço: </b>{{ movimentacao.produtor.endereco }}
                  </p>
                  <p v-if="movimentacao && movimentacao.produtor">
                    <b>Município: </b>{{ movimentacao.produtor.cidade }}
                  </p>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <p v-if="movimentacao">
                    <b>CPF/CNPJ: </b> {{ movimentacao.cnpj === null ? movimentacao.cnpj : movimentacao.cpf }}
                  </p>
                  <p v-if="movimentacao && movimentacao.produtor">
                    <b>Ins. Rural: </b>{{ movimentacao.produtor.inscricaoestadual }}
                  </p>
                  <p v-if="movimentacao">
                    <b>UF: </b>{{ movimentacao.uf }}
                  </p>
                  <p v-if="movimentacao">
                    <b>CEP: </b>{{ movimentacao.cep }}
                  </p>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <div v-if="exibeBtnDownload">
        <v-btn
          id="btnDownload"
          class="button__full"
          elevation="2"
          fab
          small
          color="primary"
          floating
          @click="generatePDF()"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </div>
      <v-simple-table>
        <thead class="header">
          <tr>
            <th
              colspan="1"
              class="primary--text text-center"
            />
            <th
              colspan="2"
              class="primary--text text-center"
            >
              Proventos
            </th>
            <th
              colspan="4"
              class="primary--text text-center"
            >
              Despesas Gerais
            </th>
          </tr>
          <tr>
            <th class="primary--text text-center">
              Mês
            </th>
            <th class="primary--text text-center">
              Litros
            </th>
            <th class="primary--text text-center">
              Valor Bruto
            </th>
            <th class="primary--text text-center">
              Frete
            </th>
            <th class="primary--text text-center">
              Veterinária
            </th>
            <th class="primary--text text-center">
              Funrural/Senar
            </th>
            <th class="primary--text text-center">
              Diversos
            </th>
          </tr>
        </thead>
        <tbody class="tabela">
          <tr
            v-for="(item, index) in listamovimentacao"
            :key="index"
          >
            <td class="text-center">
              {{ item.mes }}
            </td>
            <td class="text-center">
              {{ formateNum(item.litros) }}
            </td>
            <td class="text-center">
              {{ parseMoeda(item.valorBruto) }}
            </td>
            <td class="text-center">
              {{ parseMoeda(item.frete) }}
            </td>
            <td class="text-center">
              {{ parseMoeda(item.veterinaria) }}
            </td>
            <td class="text-center">
              {{ parseMoeda(item.funruralsenar) }}
            </td>
            <td class="text-center">
              {{ parseMoeda(item.diversos) }}
            </td>
          </tr>
          <tr>
            <td class="text-center totalizador">
              <b>Total</b>
            </td>
            <td class="text-center totalizador">
              {{ formateNum(totalLitros) }}
            </td>
            <td class="text-center totalizador">
              {{ parseMoeda(totalValorBruto, 2) }}
            </td>
            <td class="text-center totalizador">
              {{ parseMoeda(totalFrete, 2) }}
            </td>
            <td class="text-center totalizador">
              {{ parseMoeda(totalVeterinaria, 2) }}
            </td>
            <td class="text-center totalizador">
              {{ parseMoeda(totalFunruralSenar, 2) }}
            </td>
            <td class="text-center totalizador">
              {{ parseMoeda(totalDiversos, 2) }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </v-dialog>
</template>
<script>
  import CardEmpresa from '../component/CardEmpresa'
  import utils from '../../../services/utils'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardFormsListaMovimentacaoLeiteForm',
    components: {
      // CardEmpresa,
    },
    mixins: [CardEmpresa, utils],
    props: {
      movimentacao: {
        type: Object,
        default: function () {
          return {
            id: 0,
            idProdutor: 0,
            nomePropriedade: '',
            codigo: '',
            endereco: '',
            cpf: '',
            cnpj: '',
            inscEstadual: '',
            municipio: '',
            uf: '',
            cep: '',
            ano: '',
            produtor: {
              nome: '',
            },
          }
        },
        listamovimentacao: {
          type: Array,
          default: function () {
            return [{
              mes: '',
              litros: 0,
              valorBruto: 0,
              frete: 0,
              veterinaria: 0,
              funrural: 0,
              senar: 0,
              diversos: 0,
            }]
          },
        },
      },
      exibedialog: {
        type: Boolean,
        default: false,
      },
      empresaMovimentacao: {
        type: Object,
        default: function () {
          return {}
        },
      },
      bodyData: {
        type: Array,
        default: function () {
          return []
        },
      },
    },
    data: () => ({
      exibedialogInterno: false,
      listamovimentacao: [],
      totalLitros: 0,
      totalValorBruto: 0,
      totalFrete: 0,
      totalVeterinaria: 0,
      totalDiversos: 0,
      totalFunruralSenar: 0,
    }),
    watch: {
      exibedialog: function (val) {
        this.exibedialogInterno = val
        this.listamovimentacao = this.movimentacao.ListaMovimentacaoLeite.map((item) => {
          return ({
            contratoId: item.contratoId,
            diversos: this.parseMoeda(item.diversos, 4),
            frete: this.parseMoeda(item.frete, 2),
            funruralsenar: this.parseMoeda(item.funruralsenar, 2),
            id: item.id,
            listamovimentacaoId: item.listamovimentacaoId,
            litros: this.formateNum(item.litros),
            mes: item.mes,
            movimentacaoLeite: this.parseMoeda(item.movimentacaoLeite, 2),
            valorBruto: this.parseMoeda(item.valorBruto, 2),
            veterinaria: this.parseMoeda(item.veterinaria, 2),
          })
        })
        this.totalLitros = this.movimentacao.totalLitros
        this.totalFrete = this.movimentacao.totalFrete
        this.totalValorBruto = this.movimentacao.totalValorBruto
        this.totalVeterinaria = this.movimentacao.totalVeterinaria
        this.totalFunruralSenar = this.movimentacao.totalFunruralSenar
        this.totalDiversos = this.movimentacao.totalDiversos
      },
    },
    methods: {
      fechaDialog () {
        this.exibedialogInterno = false
        this.$emit('update-dialog', this.exibedialogInterno)
      },
      exibeBtnDownload () {
        return !navigator.userAgent.match(/iPhone/i)
      },
      async generatePDF () {
        const doc = new JSPDF({
          orientation: 'portrait',
          unit: 'px',
          format: 'a4',
          compress: true,
        })
        // doc.text(x,y) x posição horizontalo e y posição vertical
        var iniciopag = 20
        doc.text(90, iniciopag, `Informe de Rendimento do Exercício de ${this.movimentacao.ano} `)
        var pageWidth = doc.internal.pageSize.getWidth()

        var x1 = 2 // posição x inicial da linha
        var x2 = pageWidth - 3 // posição x final da linha (largura da página - 3 para margens)
        var y = 25 // posição y da linha

        doc.setLineWidth(1.0) // define a largura da linha
        doc.line(x1, y, x2, y)

        doc.setFontSize(12)
        doc.text(10, iniciopag + 15, 'Produtor: ' + this.movimentacao.produtor.nome)
        doc.text(290, iniciopag + 15, 'CPF/CNPJ: ' + this.movimentacao.produtor.cpf)

        doc.setFontSize(12)
        doc.text(10, iniciopag + 26, 'Propriedade: ' + this.movimentacao.nomePropriedade)
        doc.text(290, iniciopag + 26, 'Insc. Rural: ' + this.movimentacao.produtor.inscricaoestadual)

        doc.setFontSize(12)
        doc.text(10, iniciopag + 37, 'Endereço: ' + this.movimentacao.produtor.endereco)

        doc.setFontSize(12)
        doc.text(10, iniciopag + 48, 'Municipio: ' + this.movimentacao.produtor.cidade)
        doc.text(290, iniciopag + 48, 'UF: ' + this.movimentacao.produtor.estado)
        doc.text(330, iniciopag + 48, 'Cep: ' + this.movimentacao.produtor.cep)

        // Tamanho da fonte
        doc.setFontSize(9)

        var texto = `Prezado senhor, para fins de DECLARAÇÃO DE IMPOSTO DE RENDA E CADASTRO RURAL, informamos o seu fornecimento de leite durante o ano de ${this.movimentacao.ano}, conforme a discriminação abaixo:`

        var maxWidth = doc.internal.pageSize.getWidth() - 10

        var textLines = doc.splitTextToSize(texto, maxWidth)

        var ty = iniciopag + 60

        textLines.forEach(function (line) {
          doc.text(10, ty, line)
          ty += 10
        })
        doc.autoTable({
          margin: { top: 0, right: 10, left: 86, bottom: 0 },
          headStyles: {
            valign: 'middle',
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
            halign: 'center',
            fontSize: 9,
            fontStyle: 'bold',
          },
          head: [[
            { title: 'PROVENTOS', styles: { fillColor: [0, 0, 0, 0.1], textColor: [0, 0, 0], halign: 'center', fontSize: 9, fontStyle: 'bold', lineWidth: 0.1 } },
            { title: 'DESPESAS GERAIS', styles: { fillColor: [0, 0, 0, 0.1], textColor: [0, 0, 0], halign: 'center', fontSize: 9, fontStyle: 'bold', lineWidth: 0.1 } },
          ]],
          body: [
            ['', '', ''],
            ['', '', ''],
          ],
          theme: 'grid',
          startY: iniciopag + 80,
          startX: 100,
        })
        const columns = [
          { title: 'Mês', dataKey: 'mes' },
          { title: 'Litros', dataKey: 'litros', typeof: 'number' },
          { title: 'Valor Bruto', dataKey: 'valorBruto', typeof: 'number' },
          { title: 'Frete', dataKey: 'frete', typeof: 'number' },
          { title: 'funrural/senar', dataKey: 'funruralsenar', typeof: 'number' },
          { title: 'Diversos', dataKey: 'diversos', typeof: 'number' },
        ]

        doc.autoTable({
          margin: { top: 0, right: 10, left: 10, bottom: 0 },
          headStyles: {
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
            halign: 'center',
            fontSize: 9,
            lineWidth: 0.1,
          },
          columns,
          body: this.listamovimentacao,
          startY: iniciopag + 95,
          startX: 120,
          theme: 'grid',
        })

        doc.autoTable({
          margin: { left: 10, right: 10 },
          styles: {
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
            halign: 'left',
            fontSize: 9,
          },
          head: [['Total de Litros', 'Total do Valor Bruto', 'Total do Frete']],
          body: [[this.formateNum(this.totalLitros) + ' Lts', this.parseMoeda(this.totalValorBruto, 2), this.parseMoeda(this.totalFrete, 2)]],
        })
        doc.autoTable({
          margin: { left: 10, right: 10 },
          styles: {
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
            halign: 'left',
            fontSize: 9,
          },
          head: [['Total de Veterinária', 'Total de Funrural/Senar', 'Total Diversos']],
          body: [[this.parseMoeda(this.totalVeterinaria, 2), this.parseMoeda(this.totalFunruralSenar, 2), this.parseMoeda(this.totalDiversos, 2)]],
        })

        var posAt = 100
        doc.text('Atenciosamente: ', posAt, doc.internal.pageSize.height - 150)
        doc.text('__________________________________________________________', posAt + 55, doc.internal.pageSize.height - 150)
        doc.text(this.movimentacao.empresa_razao, posAt + 95, doc.internal.pageSize.height - 140)

        var posAss = (this.movimentacao.produtor.nome).length + 110
        doc.text('Portador: ' + this.movimentacao.produtor.nome, 10, doc.internal.pageSize.height - 50)
        doc.text('Ass: ___________________________________________', posAss, doc.internal.pageSize.height - 50)

        // footer
        var pageHeight = doc.internal.pageSize.getHeight()
        doc.line(x1, pageHeight - 10, x2, pageHeight - 10).setLineWidth(1.0).setFillColor(169, 169, 169)
        doc.setFont('times').setFontSize(10).setTextColor(0, 0, 0).text('Desenvolvido por: Magistech Sistemas - www.magistech.com.br', 100, doc.internal.pageSize.height - 0.9)

        const fileName = 'ER_' + this.movimentacao.produtor.nome + '_' + this.movimentacao.ano + '.pdf'
        var docpdf = doc.output('dataurlstring', fileName)
        const downloadLink = document.createElement('a')
        downloadLink.href = docpdf
        downloadLink.download = fileName
        const acao = 'gerarPDF'
        const dados = [
          { funcao: acao },
          { link: downloadLink.href },
          { nomearquivo: fileName },
        ]
        downloadLink.click()
        const isWebView = localStorage.getItem('platform')
        if (isWebView === 'android' || isWebView === 'ios') {
          window.ReactNativeWebView.postMessage(JSON.stringify(dados))
        }
      },
      formateNum (num) {
        return num.toLocaleString('pt-BR', { maximumFractionDigits: 2 })
      },
      formatNumber (value) {
        return value.reduce((acc, curr) => acc + parseFloat(curr[value] || 0), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },
      parseMoeda (valor, casasdecimais) {
        if (!valor || valor === 0) {
          return '0,00'
        } else {
          valor = valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: casasdecimais })
          return valor
        }
      },
      parseMoedaBr (numero) {
        var numeroString = numero.toString().replace(',', '.')
        var partes = numeroString.split('.')
        partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        if (partes[1] && partes[1].length > 2) {
          partes[1] = partes[1].substring(0, 2)
        }
        return partes.join(',')
      },
      casasDecimais (valor) {
        return parseFloat(valor.replace('.', '').replace(',', '.'))
      },

      formatarComoMoedaBrasileira (valor) {
        return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },
    },
  }
</script>
<style scoped>
  #btnDownload {
    position: fixed;
    top: 100px;
    right: 20px;
  }
  .totalizador{ font-weight: bold;}
  #btnDownload {
    position: fixed;
    top: 70px;
    right: 12px;
    z-index: 999;
  }
  .header th, .header td {
    border: 1px solid #D3D3D3;
  }
  .tabela th, .tabela td {
    border: 1px solid #D3D3D3;
  }
  #dashboard-card-cabecalho {
    border-bottom: none;
  }
  .v-simple-table{
    margin-top: 0;
  }
</style>
